import { render, staticRenderFns } from "./BasePlanDetail.vue?vue&type=template&id=0cfc1968&scoped=true"
import script from "./BasePlanDetail.vue?vue&type=script&lang=js"
export * from "./BasePlanDetail.vue?vue&type=script&lang=js"
import style0 from "./BasePlanDetail.vue?vue&type=style&index=0&id=0cfc1968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc1968",
  null
  
)

export default component.exports